exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-size: 27px;\n  font-weight: 300;\n}\n\nul, li {\n  list-style: none;\n  margin-left: 0px;\n}\n\nh4 {\n  font-size: 14px;\n  font-weight: 300;\n}\n\na {\n  margin-top: -10px;\n}\n\n.content {\n  padding: 10px;\n}\n\np.image {\n  padding-top: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/display-headline/display-headline.component.css
// module id = ../../../../../src/app/display-headline/display-headline.component.css
// module chunks = main